import { useState } from 'react';
import { OwnerForm } from '@/components/owners/owner-form';
import { OwnerTable } from '@/components/owners/owner-table';
import { useOwnerStore } from '@/lib/owner-store';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

export function OwnersPage() {
  const [showForm, setShowForm] = useState(false);
  const { addOwner } = useOwnerStore();

  const handleSubmit = async (data: { name: string; email?: string; organization?: string }) => {
    await addOwner(data);
    setShowForm(false);
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Task Owners</h1>
        <Button onClick={() => setShowForm(true)} className="flex items-center gap-2">
          <Plus className="w-4 h-4" />
          Add Owner
        </Button>
      </div>

      {showForm && (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold mb-4">Add New Owner</h2>
          <OwnerForm 
            onSubmit={handleSubmit}
            onCancel={() => setShowForm(false)}
          />
        </div>
      )}

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <OwnerTable />
      </div>
    </div>
  );
}